// React
import { useEffect, useState } from "react";
// import React, { useContext, useEffect, useState, useRef } from "react";

import { useTranslation } from "react-i18next";

// Utility functions, hooks, and API endpoints
import useUserData from "../../../utils/hooks/useUserData";
import { getKPIMetrics } from "../../../api/endpoints/kpi";

// Components
import { TopBarTop, TopBarBottom } from "../../components/TopBar/style";
import {
  BlockWrapper,
  LargeBlockContainer,
  ViewStatsWrapper,
  SmallBlockContainer,
} from "./ViewStats.styled";
import { Typography } from "../../../components/Typography";
import LargeBlock from "./LargeBlock/LargeBlock";
import SmallerBlock from "./SmallerBlock/SmallerBlock";

const ViewStats = ({ stats, isHidden }) => {
  const { t, i18n } = useTranslation();

  // Get user data
  const { userData } = useUserData();

  const [kpiMetrics, setKpiMetrics] = useState(null);
  const [isLoadingKPI, setIsLoadingKPI] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoadingKPI(true);
      try {
        const response = await getKPIMetrics();
        if (response && response.metrics) {
          setKpiMetrics(response.metrics);
        }
        setIsLoadingKPI(false);
      } catch (error) {
        setIsLoadingKPI(false);
        setError(error);
      }
    };
    fetchData();
  }, []);

  return (
    <ViewStatsWrapper isHidden={isHidden}>
      <TopBarTop />
      <TopBarBottom />
      <BlockWrapper>
        {userData && userData.firstName && (
          <Typography tag="title" nomargin mb="100">
            {t("common.welcome", "Welcome")} {userData.firstName}!
          </Typography>
        )}

        <LargeBlockContainer>
          <LargeBlock
            title={t("common.applied", "Applied")}
            subtitle={t("common.candidatesInTotal", "Candidates in total")}
            count={kpiMetrics?.applied ?? 0}
            isLoading={isLoadingKPI}
          />
          <LargeBlock
            title={t("common.shortlisted", "Shortlisted")}
            subtitle={t("common.candidatesInTotal", "Candidates in total")}
            count={kpiMetrics?.shortlisted ?? 0}
            isLoading={isLoadingKPI}
          />
          <LargeBlock
            title={t("common.interview", "Interview")}
            subtitle={t("common.candidatesInTotal", "Candidates in total")}
            count={kpiMetrics?.interview ?? 0}
            isLoading={isLoadingKPI}
          />
        </LargeBlockContainer>

        <SmallBlockContainer>
          {/* <SmallerBlock
            title={"Unread applications"}
            count={kpiMetrics?.unread ?? 0}
            subtitle={t("common.unread_applications_subtitle", {
              positionsCount: kpiMetrics?.positionsCount ?? 0,
            })}
            isLoading={isLoadingKPI}
            highlight
          /> */}
          <SmallerBlock
            title={t("common.hired", "Hired")}
            subtitle={t("common.employmentsInTotal", "Employments in total")}
            count={kpiMetrics?.hired ?? 0}
            isLoading={isLoadingKPI}
          />
        </SmallBlockContainer>
      </BlockWrapper>
    </ViewStatsWrapper>
  );
};

export default ViewStats;
